var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex items-center justify-center loader",class:{ 'loader--vertical': _vm.contentPosition === 'vertical' },style:({
    paddingTop: (_vm.paddingTop + "px"),
    paddingBottom: (_vm.paddingBottom + "px"),
  })},[_c('i',{staticClass:"circle-loader"}),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.text)}})])}
var staticRenderFns = []

export { render, staticRenderFns }